import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faPen,
  faPlus,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import Add_offcanvas from "./add_offcanvas/Add_offcanvas";
import Edit_offcanvas from "./edit_offcanvas/Edit_offcanvas";
import rejectAnimation from "../../../../../animation/success_lottie/Reject_lottie.json";
import successAnimation from "../../../../../animation/success_lottie/Success_lottie.json";
import Success_modal from "../../../../../common_components/common_modal/success_modal/Success_modal";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../../../utils/IDS";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../../../../utils/context";
import {
  allAcceptRejectStatus,
  // UpdateInternshipStatus,
} from "../../../../../../features/admin/common/Slice"; // Adjust path if needed
import { UpdateInternshipStatus } from "../../../../../../features/admin/internship/internship/Slice";

const Internship = () => {
  const { isAllow: permissions, usertype, userdata } = useContext(Context);
  const dispatch = useDispatch();
  const isAdmin = userdata?.role === "Admin";

  const allacceptrejectstatus = useSelector(
    (state) => state.common.all_accept_reject_status || []
  );

  useEffect(() => {
    if (!allacceptrejectstatus || allacceptrejectstatus.length === 0) {
      dispatch(allAcceptRejectStatus());
    }
  }, [dispatch]);

  const hasPermission = (ids) => {
    if (usertype === "admin") return true;
    if (!Array.isArray(permissions)) return false;
    return ids.some((id) => permissions.includes(id));
  };

  const {
    country,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [modalRejectShow, setModalRejectShow] = useState(false);
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showEditCanvas, setShowEditCanvas] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);

  // New state for status update
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [updatingStatus, setUpdatingStatus] = useState(false);

  const handleView = (row) => {
    setViewData(row);
    setSelectedStatus(null); // IMPORTANT
    setShowViewModal(true);
  };

  const handleStatusChange = async () => {
    if (!selectedStatus || !viewData?.id) return;

    setErr(false);
    setSuccess(false);
    setUpdatingStatus(true);

    try {
      const res = await dispatch(
        UpdateInternshipStatus({
          id: viewData.id,
          accept_reject_status_id: selectedStatus,
        })
      );

      if (res.meta.requestStatus === "fulfilled") {
        setSuccess(true);
        setViewData({
          ...viewData,
          accept_reject_status_id: selectedStatus,
        });
        await fetch();
      } else {
        setErr(true);
      }
    } catch (error) {
      setErr(true);
    } finally {
      setUpdatingStatus(false);
    }
  };

  const handleStatusSelect = (statusId) => {
    setSelectedStatus(statusId);
  };

  const handleDelete = async () => {
    const success = await deleteData(deleteId);
    if (success) {
      setShowDeleteModal(false);
      setDeleteId(null);
      setSuccess(true);
    } else {
      setErr(true);
    }
  };

  const courseRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const [openStatus, setOpenStatus] = useState(false);

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>
          <div className="dropdown_wrapper">
            {permissions?.includes(IDS.Permission.Internship.Add) && (
              <button
                className="dark_btn"
                disabled={isAdmin}
                onClick={() => {
                  if (isAdmin) return;
                  setShowAddCanvas(true);
                }}
                style={{
                  opacity: isAdmin ? 0.5 : 1,
                  cursor: isAdmin ? "not-allowed" : "pointer",
                }}
              >
                Add
                <div className="aap_icon_holder">
                  <FontAwesomeIcon icon={faPlus} />
                </div>
              </button>
            )}
          </div>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Internships</h5>
          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Hotel Name</th>
                  <th>Internship Name</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {country?.data?.length > 0 ? (
                  country?.data?.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(country?.current_page - 1) * country?.per_page +
                          index +
                          1}
                      </td>
                      <td>{val?.User?.name}</td>
                      <td>{val?.name}</td>
                      <td>
                        <Form.Check
                          type="switch"
                          id={`custom-switch-${val?.id}`}
                          checked={val?.status}
                          onChange={() => toggleStatus(val?.id)}
                          label={val?.status ? IDS.ACTIVE : IDS.INACTIVE}
                        />
                      </td>
                      <td>
                        <div className="action_btn_holder">
                          <Button
                            className="eye_btn action_btn_icon"
                            onClick={() => handleView(val)}
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </Button>
                          {permissions?.includes(
                            IDS.Permission.Internship.Edit
                          ) && (
                            <Button
                              className="eye_btn action_btn_icon"
                              onClick={() => setShowEditCanvas(val?.id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </Button>
                          )}
                          {permissions?.includes(
                            IDS.Permission.Internship.Delete
                          ) && (
                            <Button
                              className="eye_btn action_btn_icon"
                              disabled={isAdmin}
                              onClick={() => {
                                if (isAdmin) return;
                                setDeleteId(val.id);
                                setShowDeleteModal(true);
                              }}
                              style={{
                                opacity: isAdmin ? 0.5 : 1,
                                cursor: isAdmin ? "not-allowed" : "pointer",
                              }}
                            >
                              <FontAwesomeIcon icon={faTrashCan} />
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center fw-bold">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CustomPaginate
              currentPage={country?.current_page}
              totalPages={country?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* Add & Edit Offcanvas */}
      <Add_offcanvas
        show={showAddCanvas}
        setShow={setShowAddCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowAddCanvas(false)}
      />
      <Edit_offcanvas
        show={showEditCanvas}
        setShow={setShowEditCanvas}
        setSuccess={setSuccess}
        setErr={setErr}
        setShowRejectModal={setShowRejectModal}
        handleClose={() => setShowEditCanvas(false)}
      />

      {/* Success / Error Modals */}
      <Success_modal
        show={success}
        onHide={() => setSuccess(false)}
        message_text="Operation Successful!"
        animationData={successAnimation}
      />
      <Success_modal
        show={err}
        onHide={() => setErr(false)}
        message_text="Something went wrong!"
        animationData={rejectAnimation}
      />
      <Success_modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />

      {/* Delete Confirmation */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this Internship?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Modal with Accept/Reject */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Internship Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewData && (
            <>
              {/* Basic Info */}
              <h6 className="fw-bold">Basic Information</h6>
              <p>
                <strong>Name:</strong> {viewData.name}
              </p>
              <p>
                <strong>Title:</strong> {viewData.title}
              </p>
              <p>
                <strong>Description:</strong> {viewData.description}
              </p>
              <p>
                <strong>Stipend:</strong> ₹{viewData.stipend}
              </p>
              <p>
                <strong>Status:</strong>{" "}
                {viewData.status ? "Active" : "Inactive"}
              </p>
              <hr />

              {/* Company */}
              <h6 className="fw-bold">Company Details</h6>
              <p>
                <strong>Company:</strong> {viewData.User?.name}
              </p>
              <p>
                <strong>Email:</strong> {viewData.User?.email}
              </p>
              <hr />

              {/* Location */}
              <h6 className="fw-bold"> Accomodation Location</h6>
              <p>
                <strong>Street:</strong> {viewData.street || "N/A"}
              </p>
              <p>
                <strong>City:</strong> {viewData.city || "N/A"}
              </p>
              <p>
                <strong>Country:</strong> {viewData.country || "N/A"}
              </p>
              <p>
                <strong>Postal Code:</strong> {viewData.postal_code || "N/A"}
              </p>
              <hr />

              {/* Facilities */}
              <h6 className="fw-bold">Facilities</h6>
              <ul>
                <li>
                  Accommodation: {viewData.accomodation_status ? "Yes" : "No"}
                </li>
                <li>Meal: {viewData.meal_provided ? "Yes" : "No"}</li>
                <li>Uniform: {viewData.uniform_provided ? "Yes" : "No"}</li>
                <li>Laundry: {viewData.laundry_service ? "Yes" : "No"}</li>
              </ul>
              <hr />

              {/* Requirements & Documents */}
              <h6 className="fw-bold">Requirements</h6>
              <ul>
                {viewData.Internship_Requirements?.length > 0
                  ? viewData.Internship_Requirements.map((r, i) => (
                      <li key={i}>{r.Requirement?.name}</li>
                    ))
                  : "None"}
              </ul>

              <h6 className="fw-bold">Required Documents</h6>
              <ul>
                {viewData.Internship_Documents?.length > 0
                  ? viewData.Internship_Documents.map((d, i) => (
                      <li key={i}>{d.Document?.name}</li>
                    ))
                  : "None"}
              </ul>
              <hr />

              {/* Contacts */}
              <h6 className="fw-bold">Contact Persons</h6>
              {viewData.Internship_Contacts?.length > 0 ? (
                viewData.Internship_Contacts.map((c, i) => (
                  <div key={i} className="border p-3 mb-3 rounded">
                    <p>
                      <strong>Name:</strong> {c.name}
                    </p>
                    <p>
                      <strong>Email:</strong> {c.email}
                    </p>
                    <p>
                      <strong>Contact:</strong> {c.contact_no}
                    </p>
                    <p>
                      <strong>Position:</strong> {c.position}
                    </p>
                  </div>
                ))
              ) : (
                <p>No contacts</p>
              )}

              <hr />

              {/* === ONLY ADMINS SEE THIS SECTION === */}
              {isAdmin && (
                <>
                  <h6 className="fw-bold">Application Status</h6>

                  {/* Current Status - Read Only */}
                  <Form.Group className="mb-3">
                    <Form.Label>Current Status</Form.Label>
                    <Form.Control
                      type="text"
                      readOnly
                      value={
                        allacceptrejectstatus.find(
                          (s) => s.value === viewData.accept_reject_status_id
                        )?.label || "Process"
                      }
                    />
                  </Form.Group>

                  {/* Update Status Dropdown */}
                  <Form.Group className="mb-4">
                    <Form.Label>Update Status</Form.Label>
                    <Form.Select
                      value={selectedStatus ?? ""}
                      onChange={(e) =>
                        handleStatusSelect(Number(e.target.value))
                      }
                    >
                      <option value="">-- Select New Status --</option>
                      {allacceptrejectstatus
                        .filter(
                          (s) =>
                            s.value !== 1 && // Hide "Process"
                            s.value !== viewData.accept_reject_status_id // Hide current
                        )
                        .map((status) => (
                          <option key={status.value} value={status.value}>
                            {status.label}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>

                  {/* Update Button - Only shows when valid new status selected */}
                  {[2, 3].includes(selectedStatus) &&
                    selectedStatus !== viewData.accept_reject_status_id && (
                      <Button
                        variant="primary"
                        onClick={handleStatusChange}
                        disabled={updatingStatus}
                      >
                        {updatingStatus ? "Updating..." : "Update Status"}
                      </Button>
                    )}
                </>
              )}

              {/* Non-admins just see current status */}
              {!isAdmin && (
                <>
                  <hr />
                  <h6 className="fw-bold">Application Status</h6>
                  <p>
                    <strong>Current Status:</strong>{" "}
                    {allacceptrejectstatus.find(
                      (s) => s.value === viewData.accept_reject_status_id
                    )?.label || "Process"}
                  </p>
                </>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Internship;
